import BackgroundMask from '../../atoms/mask/backgroundMask';
import Focus from '../../../../shared/types/enums/focus';
import ZoomModalImage from '../../atoms/images/zoomModalImage';
import useKeyboard from '../../../../shared/components/utils/hooks/useKeyboard';
import {
  clearModal,
  modalSelector,
} from '../../../../shared/store/slices/modal.slice';
import {
  pushFocus,
  popFocus,
} from '../../../../shared/store/slices/focus.slice';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';

function ZoomModal() {
  const dispatch = useAppDispatch();
  const { params } = useAppSelector(modalSelector);

  useKeyboard({
    focus: Focus.MODAL_ZOOM,
    keyDownHandler: () => null,
    keyUpHandler: (key) => {
      if (key === 'BACK') {
        dispatch(popFocus());
        dispatch(clearModal());
      }
    },
  });

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_ZOOM));
  }, []);

  const { src, width } = params as { src: string; width: number };

  return (
    <BackgroundMask>
      <ZoomModalImage src={src} width={width}></ZoomModalImage>
    </BackgroundMask>
  );
}

export default ZoomModal;
